import { Grid, pn, Stack, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import {
  ControlGroupStudentFilter as ControlGroupStudentFilterModel,
  ControlGroupStudentFilterResource
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const ControlGroupStudentFilter = (props: {
  filter: ControlGroupStudentFilterModel;
  setFilter: (filter: ControlGroupStudentFilterModel) => void;
}) => {
  const { breakpointsRef, largeFieldBreakpoints, fullFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<ControlGroupStudentFilterResource>({} as ControlGroupStudentFilterResource);
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.students.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const schoolYearField = () => {
    const propertyName = pn<ControlGroupStudentFilterModel>("schoolYears");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.schoolYearsWithActive?.filter((x) => props.filter.schoolYears?.includes(x.id))}
        options={resource.schoolYearsWithActive}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolYears = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  const schoolsField = () => {
    const propertyName = pn<ControlGroupStudentFilterModel>("schoolIds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.schools?.filter((x) => props.filter.schoolIds?.includes(x.id))}
        options={resource.schools}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolIds = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  const gradeLevelsField = () => {
    const propertyName = pn<ControlGroupStudentFilterModel>("gradeLevelIds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.gradeLevels?.filter((x) => props.filter.gradeLevelIds?.includes(x.id))}
        options={resource.gradeLevels}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.gradeLevelIds = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  return (
    <Stack ref={breakpointsRef} spacing="lg">
      <Grid container spacing="sm">
        <Grid item xs={largeFieldBreakpoints}>
          {schoolYearField()}
        </Grid>

        <Grid item xs={largeFieldBreakpoints}>
          {gradeLevelsField()}
        </Grid>

        <Grid item xs={fullFieldBreakpoints}>
          {schoolsField()}
        </Grid>
      </Grid>
    </Stack>
  );
};
